import Product from './Product';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import defaultProps from 'recompose/defaultProps';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { withModel } from '../../../data-providers/model';

const enhance = compose(
  withModel,
  defaultProps({
    isPriceHidden: false
  }),
  mapProps(props => ({
    ...props,
    ageString: props.ageString
      .replace(/%{min}/g, props.minimumAge)
      .replace(/%{max}/g, props.maximumAge),
    link: localiseUrl(props.model.countryModel, `/personalized-products/${props.slug}`),
  })),
);

export default enhance(Product);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductList/Product/index.js